import React from "react";
import classnames from "classnames";

export class PromiseButton extends React.Component {
    state = {};

    doAction = e => {
        if (e) {
            e.preventDefault();
        }

        this.setState({ processing: true, failure: false });
        let promised = this.props.doAction();
        if (promised && promised.then) {
            promised
                .then(() =>
                    this.setState({ processing: false, failure: false })
                )
                .catch(e =>
                    this.setState({
                        processing: false,
                        failure: true
                    })
                );
        } else {
            console.warn("PromiseButton doAction not a promise");
            setTimeout(() => {
                this.setState({
                    processing: false
                });
            }, 1000);
        }
    };

    render() {
        let buttonClass;
        let { status, processing, failure } = this.state;
        let { noProcessingAnimation } = this.props;

        buttonClass = classnames(
            "button",
            this.props.className,
            this.props.iconClass,
            {
                "button-process": !noProcessingAnimation,
                disabled: noProcessingAnimation && processing,
                processing,
                failure,
                "button-icon": this.props.iconButton && !status
            }
        );

        let onClick;
        if (!processing) {
            onClick = this.doAction;
        }

        return (
            <div className="process-button-wrapper">
                <button onClick={onClick} className={buttonClass}>
                    <span>{this.props.children}</span>
                </button>
            </div>
        );
    }
}
